export const SearchingIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M8.5 14h.79l.28-.27A6.471 6.471 0 0 1 8 9.5A6.5 6.5 0 1 1 14.5 16c-1.61 0-3.09-.59-4.23-1.57l-.27.28v.79l-5 4.99L3.51 19l4.99-5zm6 0C16.99 14 19 11.99 19 9.5S16.99 5 14.5 5S10 7.01 10 9.5S12.01 14 14.5 14z"
            />
        </svg>
    );
};
